import { SocialSectionDataProps } from 'mm-ui-components/dist/src/base/components/navigation/footer/AdditionalFooterSections/FooterSocialLinks';
import { NavigationLink } from 'mm-ui-components/dist/src/base/components/navigation/header/primaryHeader/PrimaryHeader';
import { LinkButtonDataProps } from 'mm-ui-components/dist/src/base/components/navigation/utils';
import { MenuLinkDataProps } from 'mm-ui-components/dist/src/base/components/navigation/header/primaryHeader/menu/links/MenuSubLink';
import {
  INJECT_BUTTON_TO_MENU,
  INJECT_VIDEO_LOGO,
  InjectButtonToMenuAction,
  InjectVideoLogoAction,
  InjectVideoLogoParams,
} from '../../navigation.actions';

type Link = {
  text: string;
  href: string;
};

export interface MenuLink extends Link {
  childrenLinks: Array<Link>;
}

export interface MenuData {
  links: MenuLinkDataProps[];
  oldSocialSection?: SocialSectionDataProps | null;
  socialSection?: SocialSectionDataProps | null;
  buttons?: Array<LinkButtonDataProps>;
}

export interface HeaderWithSubMenusState {
  logo: {
    src: string;
    svgViewBox: string;
    alt: string;
    href: string;
  };
  links: NavigationLink[] | null;
  editions: NavigationLink[] | null;
  cta: Link | null;
  menu: MenuData | null;
  pagePath: string;
  editionEndpoint: string;
  videoLogo?: InjectVideoLogoParams;
  oldSocialSection: SocialSectionDataProps | null;
  moreButtonText: string;
  editionsIcon: null;
}

export type HeaderWithSubMenusAction = InjectVideoLogoAction | InjectButtonToMenuAction;

export const headerWithSubMenusReducer = (state: HeaderWithSubMenusState = {} as HeaderWithSubMenusState, action: HeaderWithSubMenusAction) => {
  switch (action.type) {
    case INJECT_VIDEO_LOGO: {
      const { videoPath } = action;
      return {
        ...state,
        videoLogo: {
          videoPath,
        },
      };
    }
    case INJECT_BUTTON_TO_MENU: {
      const { text, onClick } = action;
      const buttons = state.menu && state.menu.buttons;
      return {
        ...state,
        menu: {
          ...state.menu,
          buttons: [
            ...(buttons || []),
            {
              text,
              onClick,
            },
          ],
        },
      };
    }
    default:
      return state;
  }
};
